import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useSectorService from '../../../app/services/hooks/useSectorService';
import { SectorDataForm } from '../../../app/models/Sector';
import SectorFormContainer from './SectorFormContainer';
import { SectorBusinessRulesEnum } from '../../../app/shared/enums';

interface Props {
    sectorId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const SectorEdit = ({ sectorId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditSector, editSector, fetchingUpdateSector, updateSector } =
        useSectorService();
    const [sector, setSector] = useState<SectorDataForm>({ name: '' });
    
    const [sectorBusinessRulesEnum, setSectorBusinessRulesEnum] = useState<SectorBusinessRulesEnum[]>([]);
    
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando sector...');
        editSector(sectorId, {
            onSuccess: (response: ServiceResponse) => {
                setSector(response.data.sector);
                setSectorBusinessRulesEnum(response.data.sector_business_rules_enum);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando sector...');
        updateSector(sectorId, sector, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditSector ? (
        <LazyLoading height="300" />
    ) : (
        <SectorFormContainer
            fetching={fetchingUpdateSector}
            sectorBusinessRulesEnum={sectorBusinessRulesEnum}
            sector={sector}
            setSector={setSector}
            action={update}
            cancel={cancel}
            errorFields={errorFields}

        />
    );
};

export default SectorEdit;
